import React, { useState } from "react";
import Page from "../../../components/Page";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import LiveTest from "./LiveTest";
import CreateLiveTest from "./CreateLiveTest";
import LiveTestRules from "./LiveTestRules";

const LiveTestTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Page title="Live Tests">
      <Box sx={{ width: "95%", margin: "auto", mt: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: "bold" }}>
          Live Tests Management
        </Typography>

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            mb: 3,
            "& .MuiTab-root": {
              fontSize: "1rem",
              fontWeight: "600",
              textTransform: "none",
            },
          }}
        >
          <Tab label="All Live Tests" />
          <Tab label="Create Live Test" />
          <Tab label="Automation Rules" />
        </Tabs>

        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && <LiveTest />}
          {activeTab === 1 && <CreateLiveTest onSuccess={() => setActiveTab(0)} />}
          {activeTab === 2 && <LiveTestRules />}
        </Box>
      </Box>
    </Page>
  );
};

export default LiveTestTabs;
